import gmapsInit from "@/restricted-library/gmaps.js";
import i18n from "@/restricted-library/i18n";
import { getLanguage } from "@/restricted-library/services/languageService";
import KeycloakPlugin from "@/restricted-library/plugins/keycloak.js";
import vuetify from "@/restricted-library/plugins/vuetify";
import store from "@/restricted-library/store";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import App from "./App.vue";
import AppointmentItem from "./components/AppointmentItem";
import AutocompleteSearch from "./components/AutocompleteSearch";
import CoveragesMonthView from "./components/Coverages/CoveragesMonthView";
import PreviousMonthsDialog from "./components/Coverages/PreviousMonthsDialog";
import EventsCardsList from "./components/EventsCardsList";
import NotificationCard from "./components/Notifications/NotificationCard";
import TheNotificationsMenu from "./components/Notifications/TheNotificationsMenu";
import TheMainMenu from "./components/main_menu/TheMainMenu";
import router from "./router";

/**
 * PLUGINS
 */
Vue.use(VueTheMask);

// C O M P O N E N T S
Vue.component("main-menu", TheMainMenu);
Vue.component("notifications-menu", TheNotificationsMenu);
Vue.component("notification-card", NotificationCard);
Vue.component("coverages-month-view", CoveragesMonthView);
Vue.component("previous-months-dialog", PreviousMonthsDialog);
Vue.component("events-cards-list", EventsCardsList);
Vue.component("autocomplete-search", AutocompleteSearch);
Vue.component("appointment-item", AppointmentItem);

Vue.config.productionTip = false;
Vue.config.devtools = true;

import dayjs from "dayjs";
import "dayjs/locale/it";
import "dayjs/locale/de";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isToday from "dayjs/plugin/isToday";
import localeData from "dayjs/plugin/localeData";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.locale(getLanguage());
dayjs.extend(utc);
dayjs.extend(timezone);
console.log("timezone from dayjs.tz.guess()", dayjs.tz.guess());
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isToday);
dayjs.extend(localeData);

// F I L T E R S / P I P E S
/**
 * it takes as an argument a Date and tranforms it to given day.js format
 *
 * Usage:
 *  date = "Thu Jul 11 2019 09:29:47 GMT+0300 (Eastern European Summer Time)"
 *  format = "DD-MM-YYYY HH:mm"
 *  {{ date | date(format) }}
 *
 * Output: "11-07-2019 09:29"
 */
Vue.filter("date", (date, format, locale) => {
  return dayjs(String(date)).locale(locale).format(format);
});

Vue.filter("titlecase", str => {
  if (str) {
    return str[0].toUpperCase() + str.slice(1);
  }
});

Vue.filter("decimals", (value, decimals) => {
  value = value || 0.0;
  let formatter = new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: decimals || 0,
    minimumFractionDigits: decimals || 0
  });
  return formatter.format(Number.parseFloat(value));
});

Vue.use(KeycloakPlugin, {
  keycloakConfig: {
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
  },
  onReady: (keycloak, authenticated) => {
    try {
      gmapsInit().then(() => {
        // wait for loading of google maps before starting vue app
        new Vue({
          vuetify,
          router,
          store,
          i18n,
          render: h => h(App)
        }).$mount("#app");
      });

      // register 'onAuthSuccess' and 'onAuthError' events
      Vue.prototype.$eventBus.$emit("onAuthSuccess");
      Vue.prototype.$eventBus.$emit("onAuthError");
      // listen for the 'onAuthLogout' event
      Vue.prototype.$eventBus.$on("onAuthLogout", () => {
        store.dispatch("doLogout", null, { root: true });
      });
    } catch (err) {
      console.error("[KEYCLOAK] -> errore durante l'onReady di Keycloak", err);
    }
  },
  eventHandlers: {
    onAuthSuccess: () => {},
    onAuthError: () => {},
    onTokenExpired: () => {},
    onAuthLogout: () => {}
  }
});
